import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";

const SolutionsView = ({
    list
}) => {
    const theme = useTheme();

    return (
        <>
            <Box
                className="sectionMarginSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.paper
                }}
            >
                <Grid
                    direction='row'
                    justifyContent='start'
                    alignItems='start'
                    container
                    width='100%'
                    spacing={{xs: 3, md: 5}}
                    p={{xs: 2, md: 10}}
                >
                    {
                        list.map((item, index) => {
                            return <Grid
                                key={index}
                                size={{xs: 12, md: 6}}
                            >
                                <SolutionDetails data={item}/>
                            </Grid>
                        })
                    }
                </Grid>
            </Box>
        </>
    );
}

export default SolutionsView;

const SolutionDetails = ({data}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='row'
                justifyContent='start'
                alignItems='start'
                spacing={{xs: 2, md: 4}}
                data-aos="slide-up"
            >
                <Stack
                    direction='column'
                    justifyContent='start'
                    alignItems='start'
                    spacing={2}
                >
                    {
                        data.icon
                        ?
                        <Box
                            sx={{
                                width: {xs: 35, md: 50}
                            }}
                        >
                            <img 
                                src={data.icon}
                                alt={data.title} 
                                width='100%'
                            />
                        </Box>
                        :
                        <></>
                    }
                    <Typography
                        fontWeight={600}
                        fontSize={{xs: 14, md: 24}}
                        textAlign='left'
                        color={theme.palette.text.primary}
                        lineHeight={1.5}
                    >
                        {data.title}
                    </Typography>

                    <Typography
                        fontWeight={500}
                        fontSize={{xs: 12, md: 12, lg: 14}}
                        textAlign="justify"
                        lineHeight={1.5}
                        color={theme.palette.text.secondary}
                    >
                        {data.description}
                    </Typography>
                </Stack>
            </Stack>
        </>
    );
}